import { Button } from '@cokitchen/cokitchen-components';
import { ExportAltIcon } from 'cokitchen-icons';
import React, { FC } from 'react';
import './styles.scss';

type Props = {
  onClick: () => void;
  className?: string;
};
const ExportButton: FC<Props> = ({ className, onClick }) => {
  return (
    <div className={`export-btn ${className}`}>
      <Button className={`${className}`} variant='block' color='gray' small onClick={onClick}>
        <ExportAltIcon />
        Export
      </Button>
    </div>
  );
};

export default ExportButton;
